/**
 * Runs first (main.tsx imports it before anything else): saved choices stored under an earlier
 * product name ('<old>.sw', '<old>.mobileOffer') move to the current name once, so a rename
 * keeps them. IndexedDB, Cache Storage and the sync tag keep their names (see the rename ADR).
 */
import { migrateLegacyStorage } from '@orgus/protocol';

function local(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

export const MIGRATED_STORAGE_KEYS: readonly string[] = migrateLegacyStorage(local());
